import { getAppcuesConfig } from '../network/ApiService'
import { useNetworkResponse } from '@activehub/common-components-spa';
import { useEffect } from 'react';
import ScriptCache from 'src/components/micro-frontend/script-cache';
export function useAppcues() {
    const appcuesConfigResponse = useNetworkResponse();
    const fetchAppcuesConfig = () => {
        appcuesConfigResponse.dispatch({ type: "STARTED" });
        const subscription = getAppcuesConfig().subscribe(
            (response) => {
                appcuesConfigResponse.dispatch({ type: "SUCCESS", payload: response });
                const scriptCache = new ScriptCache();
                const scriptUrls = [response.SCRIPT_URL]
                const isAllowed = response.ALLOWED_ORIGIN.includes(window.location.hostname);
                if (!isAllowed) return;
                scriptCache.setScripts(scriptUrls)
                    .setContainerId("appcues-scipt")
                    .load(scriptUrls).then(() => {
                        console.log('Appcues success')
                    });
            },
            (error) => {
                console.log('error fetching Appcues config')
            }
        );
    }

    useEffect(() => {
        fetchAppcuesConfig();
    }, [])

    return {
        appcuesData: appcuesConfigResponse.data
    }
}  